import { Grid, Tooltip, IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { Dispatch, VFC } from 'react';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { SiteProcessDatePicker } from '../../input/ProcessDatePicker';
import { BaseModal } from '../../../molecules/BaseModal';
import {
  TAddSiteProcessForm,
  TSiteProcessDetailData
} from '../../../../types/process';

export type TProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  constructId: number;
  setHasExpectedDays?: Dispatch<boolean>;
};

const OverallPeriodModal: VFC<TProps> = props => {
  const { isOpen, setIsOpen, constructId, setHasExpectedDays } = props;
  const classes = useStyles();

  const methods: UseFormReturn<TAddSiteProcessForm> = useForm({
    reValidateMode: 'onSubmit'
  });
  const {
    setValue,
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const { cancelSubmit, submit, endDate, handleChangeEndDatePicker } = useHooks(
    {
      setIsOpen,
      constructId,
      setValue,
      reset,
      isOpen,
      setHasExpectedDays
    }
  );

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(submit, (formErrors: any) => {})}
      handleCancelSubmit={cancelSubmit}
      title={'工事期間の設定をしてください'}
      buttonCaption={'決定'}
      cancelButtonCaption={'キャンセル'}
    >
      <FormProvider {...methods}>
        {/* 期間 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <label className={classes.label}>期間*</label>
            <Tooltip
              title={
                <>
                  登録内容は工事詳細の契約予定日〜竣工予定日に反映されます。
                  <br />
                  <br />
                  <strong>工事期間とは</strong>
                  <br />
                  ・工事詳細の、契約予定日〜竣工予定日と連動。
                  <br />
                  ・工事情報に登録されていれば、自動で日付が反映される。
                  <br />
                  ・工事情報に登録がない場合、ここでの設定値が工事情報に反映される。
                </>
              }
              arrow
              placement='top'
            >
              <IconButton size='small' style={{ padding: 4 }}>
                <HelpIcon color='action' />
              </IconButton>
            </Tooltip>
          </div>
        </Grid>
        <Grid item xs={10} md={7}>
          <div className={classes.leftAlignContainer}>
            <Grid container>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='start_date'
                    label='開始日'
                    required={true}
                    fullWidth={true}
                    toDate={endDate}
                    errorMessage={errors?.start_date?.message}
                    className={classes.gridItem}
                    errorMessageStyle={{ display: 'none' }}
                  />
                </div>
                <div className={classes.itemMargin}>
                  <label>(契約予定日)</label>
                </div>
              </Grid>
              <Grid item xs={12} md={1}>
                <div className={classes.itemMargin} style={{ width: 20 }}>
                  <span className={classes.textStyle}>〜</span>
                </div>
              </Grid>
              <Grid item xs={7} md={5}>
                <div className={classes.itemMargin}>
                  <SiteProcessDatePicker
                    name='end_date'
                    label='終了日'
                    fullWidth={true}
                    onChange={handleChangeEndDatePicker}
                    className={classes.gridItem}
                  />
                </div>
                <div className={classes.itemMargin}>
                  <label>(竣工予定日)</label>
                </div>
              </Grid>
              {errors.start_date && (
                <Grid item xs={12}>
                  <div className={`${classes.helperText} ${classes.gridItem}`}>
                    {errors.start_date.message}
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        {/* /期間 */}
      </FormProvider>
    </BaseModal>
  );
};

export { OverallPeriodModal };
